var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-x atom-contents"},[_c('div',{ref:"button",staticClass:"small-12 cell wide-btn vertical-align-middle success",class:{ active: _vm.active },attrs:{"tabindex":"0"},on:{"click":_vm.clicked,"keyup":_vm.clicked}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }